import { createFileRoute } from "@tanstack/react-router";
import { faqs } from "@/components/hirekit/data";
import { faqJsonLd, jsonLdScript, pageHead } from "@/components/site/seo-copy";
import MainView from "@/components/cl/views/MainView";

export const Route = createFileRoute("/")({
  head: () => ({
    ...pageHead("/"),
    scripts: [jsonLdScript(faqJsonLd(faqs))],
  }),
  component: MainView,
});
